import { useTranslation } from 'react-i18next';
import { ButtonWrapper, FooterButtonRowWrapper } from './styles';
import { useRestContext } from 'components/form/RestInputContext';
import { useNavigate } from 'react-router-dom';
import { useSelector } from '@redux';

interface ButtonRowProps {
  model: string;
  type?: 'create' | 'edit';
  disableSave?: boolean;
}

const ButtonRow = ({type = 'edit', disableSave, model}: ButtonRowProps) => {
  const { t } = useTranslation();
  const { form } = useRestContext();
  const navigate = useNavigate();
  const loading = useSelector<boolean>((state) => state[model].createLoading);
  const onBack = () => navigate(-1);

  return (
    <FooterButtonRowWrapper className="showTotal">
      {!disableSave && (
        
        <ButtonWrapper
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          {t(type === 'create' ? 'button.create' : 'button.save')}
        </ButtonWrapper>

      )}
      <span style={{ width: 20 }} />
      <ButtonWrapper className="btn-back" onClick={onBack}>
        {t('button.cancel')}
      </ButtonWrapper>
    </FooterButtonRowWrapper>
  );
};

export default ButtonRow;
